




































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";

import NavigationTabs from "@/components/Settings/Venue/NavigationTabs.vue";
import Table from "@/components/Common/Table.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import Error404 from "@/components/Common/Error404.vue";
import {
  EventPriceForm,
  IFacility,
  IPagination,
  ITableParams,
  IVat,
  IVenue,
  IVenuePrice
} from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    NavigationTabs,
    AlertBox,
    Error404
  }
})
export default class VenuePrices extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = ["form", "vat", "amount"];
  private venuePrices: Array<IVenuePrice> = [];
  private facilities: Array<IFacility> = [];
  private noDataExist = false;
  private defaultPrice: IVenuePrice = {
    type: "default",
    name: "Default",
    form: EventPriceForm.GROSS,
    vat_id: 1,
    amount: 0
  };
  private availableVats: Array<IVat> | null = null;
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    search: ""
  };
  private selectedVenue: IVenue | null = null;
  private selectedVenueId: string | null = null;
  private componentKey = 0;
  private showDropdown = false;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedVenueId = vm.$route.params.id;

      vm.getFacilities(() => {
        if (
          vm.selectedVenueId !== null &&
          vm.selectedVenueId !== undefined &&
          vm.selectedVenueId !== "default"
        ) {
          if (vm.$route.query.price_created) {
            swal("Success!", "The price was created.", "success").then(() => {
              window.history.pushState(
                {},
                document.title,
                window.location.pathname
              );
            });
          }
          vm.getVenue(() => {
            vm.getVenuePrices(() => {
              //
            });
          });
        }
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.venue_price_deleted === true) {
      swal("Success!", "The price was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getFacilities(() => {
      if (
        this.selectedVenueId !== null &&
        this.selectedVenueId !== undefined &&
        this.selectedVenueId !== "default"
      ) {
        this.getVenue(() => {
          this.getVenuePrices(() => {
            //
          });
        });
      }
    });
    next();
  }

  private getFacilities(successCallback?: any): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.facilities = response.data.data;
        if (!this.selectedVenueId || this.selectedVenueId === "default") {
          const selectedFacility = this.facilities.find(
            (facility: IFacility) =>
              facility.venues && facility.venues.length > 0
          );
          if (
            selectedFacility &&
            selectedFacility.venues &&
            selectedFacility.venues[0].id
          ) {
            this.selectedVenueId = `${selectedFacility.venues[0].id}`;
          }
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getVenue(successCallback?: any): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedVenue = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private getVenuePrices(successCallback?: any): void {
    this.loading = true;
    this.venuePrices = [];
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId + "/prices"
    );

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search
        }
      })
      .then((response: AxiosResponse) => {
        this.venuePrices = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteVenuePrice(priceId: number): void {
    if (this.loading || this.updating || priceId == null) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The price will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "venue-prices/" + priceId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "VenuePrices",
                query: { venue_price_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The price was deleted.", "success");
                  this.getVenuePrices(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete venue prices.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  private toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  private closeDropdown(e: any): void {
    if (!e.relatedTarget.pathname) this.showDropdown = false;
  }

  get venueName(): string {
    return (this.selectedVenue !== null && this.selectedVenue.name) || "";
  }

  @Watch("selectedVenueId")
  selectedVenueIdChanged(selectedVenueId: number): void {
    this.$router.push({
      name: "VenuePrices",
      params: { id: `${selectedVenueId}` }
    });
  }
}
